var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36.445,
    height: 36.444,
    viewBox: "0 0 36.445 36.444",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_251",
    "data-name": "Rectangle 251",
    width: 36.445,
    height: 36.444,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_580",
    "data-name": "Group 580",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_579",
    "data-name": "Group 579",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    d: "M18.222,36.446A18.223,18.223,0,1,1,36.445,18.223,18.243,18.243,0,0,1,18.222,36.446m0-35.142A16.919,16.919,0,1,0,35.141,18.223,16.938,16.938,0,0,0,18.222,1.3",
    transform: "translate(0 -0.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    d: "M17.43,32.255A14.823,14.823,0,1,1,32.253,17.431,14.84,14.84,0,0,1,17.43,32.255m0-28.343a13.52,13.52,0,1,0,13.52,13.52A13.534,13.534,0,0,0,17.43,3.911",
    transform: "translate(0.792 0.791)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    d: "M17.443,23.192H14.206a2.657,2.657,0,0,1-2.08-1L8.488,17.661A2.674,2.674,0,0,1,7.9,15.993V12.876a2.67,2.67,0,0,1,2.667-2.667H21.081a2.67,2.67,0,0,1,2.667,2.667v3.117a2.68,2.68,0,0,1-.587,1.668l-3.638,4.534a2.657,2.657,0,0,1-2.08,1M10.568,11.512A1.365,1.365,0,0,0,9.2,12.876v3.117a1.367,1.367,0,0,0,.3.852l3.638,4.534a1.359,1.359,0,0,0,1.064.51h3.237a1.359,1.359,0,0,0,1.064-.51l3.637-4.534a1.363,1.363,0,0,0,.3-.852V12.876a1.365,1.365,0,0,0-1.363-1.363Z",
    transform: "translate(2.398 3.098)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    d: "M26.432,16.19H19.71a.652.652,0,0,1-.652-.652V12.408a.651.651,0,0,1,.652-.652h6.722a.652.652,0,1,1,0,1.3h-6.07v1.827h6.07a.652.652,0,1,1,0,1.3",
    transform: "translate(5.784 3.567)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    d: "M10.118,16.19H3.4a.652.652,0,1,1,0-1.3h6.07V13.059H3.4a.652.652,0,1,1,0-1.3h6.722a.651.651,0,0,1,.652.652v3.131a.652.652,0,0,1-.652.652",
    transform: "translate(0.833 3.567)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    d: "M16.12,27.047a.652.652,0,0,1-.652-.652V20.753H13.639V26.4a.652.652,0,0,1-1.3,0V20.1a.652.652,0,0,1,.652-.652H16.12a.652.652,0,0,1,.652.652V26.4a.652.652,0,0,1-.652.652",
    transform: "translate(3.744 5.902)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    d: "M14.513,17.107a2.293,2.293,0,1,1,2.293-2.293,2.3,2.3,0,0,1-2.293,2.293m0-3.282a.989.989,0,1,0,.989.989.99.99,0,0,0-.989-.989",
    transform: "translate(3.709 3.799)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon7);
export default __webpack_public_path__ + "static/media/icon7.214a43cbff0bdb68f60b2b9367083de3.svg";
export { ForwardRef as ReactComponent };